import { useMediaQuery } from "../hooks/useMediaQuery";
import { Btn } from "./index";
import {
  addDays,
  buildDateKey,
  formatCalendarMonth,
  formatShortWeekday,
} from "../utils/dateCalendar";

export default function DateCalendarStrip({
  countsByDate = {},
  selectedDateKey,
  onSelectDate,
  calendarAnchor,
  onCalendarAnchorChange,
  isMobile: mobileLayout = false,
  countLabel = "item",
  countLabelPlural = "itens",
}) {
  const compactCalendar = useMediaQuery("(max-width: 1100px)");
  const isMobile = mobileLayout || compactCalendar;
  const visibleCalendarAnchor = calendarAnchor || new Date();
  const calendarDayCount = isMobile ? 5 : 7;
  const calendarDays = Array.from({ length: calendarDayCount }, (_, index) => addDays(visibleCalendarAnchor, index));
  const step = isMobile ? 5 : 7;

  const renderDayButton = (day) => {
    const dateKey = buildDateKey(day);
    const count = Number(countsByDate[dateKey] || 0);
    const isSelected = selectedDateKey === dateKey;
    const isToday = buildDateKey(new Date()) === dateKey;
    const countText = count > 0
      ? `${count} ${count === 1 ? countLabel : countLabelPlural}`
      : "—";

    return (
      <button
        key={dateKey}
        type="button"
        className="rf-calendar-day"
        aria-pressed={isSelected}
        aria-current={isToday ? "date" : undefined}
        aria-label={`${day.toLocaleDateString("pt-BR")}: ${countText}`}
        onClick={() => onSelectDate(dateKey)}
        style={{
          minWidth: 0,
          padding: isMobile ? "12px 4px" : "10px 6px",
          border: "none",

          background: isSelected ? "var(--s2)" : undefined,
          color: isSelected ? "var(--accent2)" : "var(--text)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: isMobile ? 4 : 3,
          textAlign: "center",
          cursor: "pointer",
          position: "relative",
          transition: "background 0.15s",
        }}
      >
        <div style={{ fontSize: isMobile ? 17 : 16, fontWeight: 550, lineHeight: 1.3, letterSpacing: -0.1 }}>
          {day.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" })}
        </div>
        <div style={{ fontSize: isMobile ? 10 : 12, fontWeight: 400, color: "var(--muted)", letterSpacing: 0 }}>
          {formatShortWeekday(day)}
        </div>
        {count > 0 ? (
          <span className="rf-calendar-count">
            {countText}
          </span>
        ) : (
          <span style={{
            marginTop: 2,
            fontSize: '0.8125rem',
            color: "var(--muted)",
            fontWeight: 500,
          }}
          >
            {countText}
          </span>
        )}
        {isToday && !isSelected && (
          <span style={{ position: "absolute", inset: 4, border: "1px solid rgba(249,115,22,0.35)", borderRadius: 8, pointerEvents: "none" }} />
        )}
      </button>
    );
  };

  return (
    <section className="rf-calendar-section" aria-label="Datas dos pedidos">
      <div className="rf-calendar-heading">
        <span>{formatCalendarMonth(visibleCalendarAnchor)} <span className="rf-calendar-year">{visibleCalendarAnchor.getFullYear()}</span></span>
        <div className="rf-calendar-controls">
          <Btn size="sm" variant="secondary" aria-label="Datas anteriores" onClick={() => onCalendarAnchorChange(addDays(visibleCalendarAnchor, -step))}>←</Btn>
          <Btn size="sm" variant="secondary" aria-label="Próximas datas" onClick={() => onCalendarAnchorChange(addDays(visibleCalendarAnchor, step))}>→</Btn>
          <Btn size="sm" variant="secondary" aria-pressed={!selectedDateKey} onClick={() => onSelectDate("")}>Ver todas</Btn>
        </div>
      </div>
      <div className="rf-calendar" style={{ display: "grid", gridTemplateColumns: `repeat(${calendarDays.length}, minmax(0, 1fr))` }}>
        {calendarDays.map(day => renderDayButton(day))}
      </div>
    </section>
  );
}
